import { reactive, computed } from 'vue';
import { GET, POST, PUT } from '@/packge/http';
import { message } from 'ant-design-vue';
import store from '@/store';

export const avatarBorder = computed(() => {
  let border = '';
  if (!formState.fileUrl && !formState.avatar) {
    border = '1px solid #E9EDF3';
  }
  return border;
});

export const formState = reactive({
  avatar: '',
  nickName: undefined,
  phonenumber: undefined,
  sex: undefined,
  sexDesc: undefined,
  uid: false
});

export const getUserInfo = () => {
  GET({
    url: '/user/getInfo',
    params: {}
  }).then(({ data }) => {
    for (let item in data) {
      if (formState.hasOwnProperty(item)) {
        formState[item] = data[item];
        if (item === 'phonenumber') {
          sessionStorage.phonenumber = data[item];
        }
      }
    }
    cropAvatar();
  });
};

/** 头像裁剪 */
export function cropAvatar () {
  const img = new Image();
  img.src = formState.fileUrl || formState.avatar;
  const obj = {
    backgroundImage: `url(${formState.avatar})`,
    backgroundPosition: 'center',
    // Fill the preview area while preserving the image aspect ratio.  Using
    // `cover` avoids side gaps when a square avatar is shown in the wider
    // mobile edit modal; the excess part is cropped around the center.
    backgroundSize: 'cover',
    // Prevent the cropped avatar from repeating when the preview container is
    // wider or taller than the image (for example, in the mobile edit modal).
    backgroundRepeat: 'no-repeat'
  };
  img.onload = function () {
    formState.avatarStyle = obj;
  };
  store.commit('setUserInfo', formState);
}

export const bindData = reactive({
  phonenumber: '',
  isBindEmail: '',
  isBindVOS: '',
  bindDeviceCount: '',
  bindAppCount: '',
  bindOtherCount: ''
});

/** 获取用户绑定信息 */
export function getBingInfo () {
  GET({
    url: '/account/bingInfo',
    params: {}
  }).then(({ data }) => {
    for (let item in bindData) {
      bindData[item] = data[item];
    }

    const thirdAccount = data.isBindVOS && data.isBindVOS.filter(item => item.status);
    bindData.isBindVOS = thirdAccount.length ? thirdAccount.length : null;
  });
}

export const onSubmit = (refresh = true, handle = () => {}) => {
  return new Promise((resolve) => {
    let data = { ...formState };
    if (data.avatar.includes('http')) { // 处理没有修改头像直接提交情况
      delete data.avatar;
    }
    data.fileUrl && delete data.fileUrl;
    data.fileId && delete data.fileId;

    handle(data);

    PUT({
      url: '/user',
      params: data
    }).then(({ data }) => {
      message.success('修改成功');
      resolve();
      refresh && getUserInfo();
    });
  });
};

export function triggerInput (event) {
  event.stopPropagation();
  document.getElementById('uploadInput').click();
}

// 先限制用户选择的原图不超过后端要求，再统一压缩以提升上传速度。
const MAX_SOURCE_AVATAR_SIZE = 3 * 1024 * 1024;
const TARGET_AVATAR_SIZE = 1.5 * 1024 * 1024;
const MAX_AVATAR_DIMENSION = 1600;
const INITIAL_QUALITY = 0.88;
const MIN_QUALITY = 0.8;
const SUPPORTED_IMAGE_MESSAGE = '支持jpg、png、bmp、jpeg、gif，大小不超过3mb';
const SUPPORTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif'];
const SUPPORTED_IMAGE_EXTENSIONS = /\.(jpe?g|png|bmp|gif)$/i;

function loadImage (file) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);
    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('图片读取失败'));
    };
    image.src = objectUrl;
  });
}

function canvasToBlob (canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      blob ? resolve(blob) : reject(new Error('图片压缩失败'));
    }, type, quality);
  });
}

/**
 * 所有图片都经过一次重编码：限制最大尺寸，并尽量保持较高质量。
 * PNG 优先保留透明通道；PNG 仍然过大时才转为白底 JPEG。
 */
async function compressAvatar (file) {
  const fileType = (file.type || '').toLowerCase();
  const isSupportedType = SUPPORTED_IMAGE_TYPES.includes(fileType);
  const isSupportedExtension = SUPPORTED_IMAGE_EXTENSIONS.test(file.name || '');

  // 必须先校验格式和原图大小，不能通过压缩绕过原图 3 MB 的限制。
  if ((!isSupportedType && !isSupportedExtension) || file.size > MAX_SOURCE_AVATAR_SIZE) {
    message.error(SUPPORTED_IMAGE_MESSAGE);
    return null;
  }

  // Canvas 只读取 GIF 第一帧；GIF 使用 gifsicle WASM 压缩，保留完整动画。
  const isGif = fileType === 'image/gif' || /\.gif$/i.test(file.name || '');
  if (isGif) {
    try {
      const { default: gifsicle } = await import('gifsicle-wasm-browser');
      const inputName = 'input.gif';
      const outputFiles = await gifsicle.run({
        input: [{ file, name: inputName }],
        command: [`-O1 --lossy=40 --resize-fit ${MAX_AVATAR_DIMENSION}x${MAX_AVATAR_DIMENSION} ${inputName} -o /out/output.gif`]
      });
      const output = outputFiles && outputFiles[0];
      if (output && output.size > 0 && output.size < file.size) {
        const name = file.name.replace(/\.[^.]+$/, '') || 'avatar';
        return new File([output], `${name}.gif`, {
          type: 'image/gif',
          lastModified: Date.now()
        });
      }
    } catch (error) {
      // 压缩失败时保留原 GIF，确保动画不会因降级处理而丢失。
      return file;
    }
    return file;
  }

  const image = await loadImage(file);
  const longestSide = Math.max(image.naturalWidth || image.width, image.naturalHeight || image.height);
  const scale = Math.min(1, MAX_AVATAR_DIMENSION / longestSide);

  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round((image.naturalWidth || image.width) * scale));
  canvas.height = Math.max(1, Math.round((image.naturalHeight || image.height) * scale));
  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0, canvas.width, canvas.height);

  // Canvas 不一定支持 GIF/BMP 编码，统一输出 JPEG；PNG 保留透明通道。
  let type = fileType === 'image/png' || /\.png$/i.test(file.name || '') ? 'image/png' : 'image/jpeg';
  let quality = INITIAL_QUALITY;
  let blob = await canvasToBlob(canvas, type, quality);

  // PNG 的 quality 参数无效，体积仍较大时才转为白底 JPEG。
  if (type === 'image/png' && blob.size > TARGET_AVATAR_SIZE) {
    type = 'image/jpeg';
    context.globalCompositeOperation = 'destination-over';
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.globalCompositeOperation = 'source-over';
    blob = await canvasToBlob(canvas, type, quality);
  }

  while (blob.size > TARGET_AVATAR_SIZE && quality > MIN_QUALITY) {
    quality = Math.max(MIN_QUALITY, quality - 0.05);
    blob = await canvasToBlob(canvas, type, quality);
  }

  const extension = type === 'image/png' ? 'png' : 'jpg';
  const name = file.name.replace(/\.[^.]+$/, '') || 'avatar';
  return new File([blob], `${name}.${extension}`, {
    type,
    lastModified: Date.now()
  });
}

export async function uploadAvatar (file) {
  const input = file && file.target;
  const fileData = input && input.files && input.files[0];
  if (!fileData) { return false; } // 选中文件后，点击取消返回 undefined
  // 允许用户再次选择同一张图片
  input.value = '';

  let compressedFile;
  try {
    compressedFile = await compressAvatar(fileData);
  } catch (error) {
    message.error(error.message || '图片处理失败');
    return false;
  }
  if (!compressedFile) { return false; }

  let form = new FormData();
  form.set('file', compressedFile);
  return POST({
    url: '/user/uploadAvatar',
    params: form
  }).then(({ data }) => {
    formState.fileId = data.fileId;
    formState.avatar = data.fileId;
    formState.fileUrl = data.fileUrl;
    return onSubmit();
  });
}
